<template>
  <div id="container">
    <div id="left" class="column"></div>
    <div id="center" class="columns">
      <div style="padding: 20px; text-align: center">
        <el-button @click="onThree" type="primary">下载PDF</el-button>
      </div>
      <div id="pdfDom">
        <div class="tui-header">
          <div class="header-all-title">
            <div class="tui-headerTitle" style="">
              {{ userInfo.SchoolName }}
            </div>
            <div class="tui-headerName">{{ dataInfo.StudentName }}成长手册</div>
            <p style="color: #4f6585; font-size: 31px">（家长版）</p>
            <div
              style="
                font-size: 31px;
                font-weight: bold;
                color: #333;
                padding-top: 100px;
              "
            >
              {{ dataInfo.GradeName }} {{ dataInfo.ClassName }}
            </div>
          </div>
          <!-- <div class="tui-name">{{ $route.query.Name }}</div>
          <div class="tui-record">成长记录</div> -->
        </div>

        <div class="tui-box">
          <div class="tui-item" v-for="(item, index) in list" :key="index">
            <div style="position: absolute; top: 10px">
              <div class="tui-item-title">
                <div>{{ item.CateName }}</div>
              </div>
              <div class="tui-border">
                <div class="tui-rate_boder">
                  <div
                    class="tui-rate"
                    v-for="(list, keys) in item.Content"
                    :key="keys"
                  >
                    <div class="tui-rate_name" style="font-size: 16px">
                      {{ list.name }}
                    </div>
                    <el-rate disabled v-model="list.value"></el-rate>
                  </div>
                </div>

                <div class="tui-images" v-if="item.ImgList != ''">
                  <div v-for="i in getImages(item.ImgList)" :key="i">
                    <img
                      style="width: 200px; height: auto"
                      :src="i + '?x-oss-process=style/imgset'"
                      alt=""
                      crossOrigin="anonymous"
                    />
                  </div>
                </div>
                <div style="padding: 20px">
                  <div class="tui-desc">
                    <span v-if="item.ParentMessage != ''"
                      >爸爸妈妈想对你说：</span
                    >{{ item.ParentMessage }}
                  </div>
                  <div class="statueTesting" v-if="item.IsStatus">
                    <div class="statueTesting_title">学期对比分析</div>
                    <div
                      style="width: 900px; height: 500px; margin: 0 auto"
                      :id="'reportEcharts' + index"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style="
            margin: 0 auto;
            height: 1350.42px;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          <img
            src="../../assets/fengdi-f1.png"
            style="width: 845px; height: 1217px; margin-top: 62px"
            alt=""
          />
        </div>
        <!-- <div style="height: 1350.42px">
          <img
            src="../../assets/fengdi-f2.png"
            style="width: 100%; height: 100%"
            alt=""
          />
        </div> -->
      </div>
    </div>
    <div id="right" class="column"></div>
  </div>
</template>
<script>
import {
  ParentAnswersPreviewAdmin,
  GetintegrationbarValuesAdmin,
  FrontParentAnswerReport,
} from "../../api/api";
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";

export default {
  data() {
    return {
      value1: 0,
      list: [],
      userInfo: {},
      dataInfo: {},
    };
  },
  created() {
    //console.log(this.$route.query);
    // this.dataInfo = JSON.parse(unescape(this.$route.query.dataInfo));
    this.dataInfo = {
      CycleId: 1676,
      StudentId: 2240,
      IsBaby: false,
      BabyLevel: 0,
      StudentName: "安安",
      GradeName: "中班",
      ClassName: "一班",
    };
    this.userInfo = JSON.parse(window.localStorage.user);
    this.$nextTick(() => {
      this.ParentAnswersPreviewAdmin();
    });
  },
  methods: {
    onThree() {
      this.btnShow = false;
      const loading = this.$loading({
        lock: true,
        text: "正在下载PDF",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var Name = this.dataInfo.StudentName;
      //console.log(Name);
      let top = document.getElementById("pdfDom");
      if (top != null) {
        top.scrollIntoView();
        top = null;
      }
      var content = document.querySelector("#pdfDom");
      html2Canvas(content, {
        useCORS: true,
        scale: 1.3, // 提升画面质量，但是会增加文件大小
      }).then(function (canvas) {
        var contentWidth = canvas.width;
        var contentHeight = canvas.height; //一页pdf显示html页面生成的canvas高度;
        var pageHeight = (contentWidth / 592.28) * 841.89; //未生成pdf的html页面高度
        var leftHeight = contentHeight; //页面偏移
        var position = 0; //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        var imgWidth = 595.28;
        var imgHeight = (592.28 / contentWidth) * contentHeight;
        var pageData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new JsPDF("", "pt", "a4"); //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89) //当内容未超过pdf一页显示的范围，无需分页
        if (leftHeight < pageHeight) {
          pdf.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
        } else {
          // 分页
          while (leftHeight > 0) {
            pdf.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89; //避免添加空白页
            if (leftHeight > 0) {
              pdf.addPage();
            }
          }
        }
        pdf.save(`${Name}成长记录.pdf`);
        loading.close();
      });
    },
    getImages(val) {
      //console.log(val);
      return val.split(",");
    },
    async ParentAnswersPreviewAdmin() {
      let params = {
        // CycTimeId: this.$route.query.CycleId,
        // YearsID: this.$route.query.StudyYearId,
        // UId: this.$route.query.UId,
        CycleId: this.dataInfo.CycleId,
        StudentId: this.dataInfo.StudentId,
        IsBaby: this.dataInfo.IsBaby,
        BabyLevel: this.dataInfo.BabyLevel,
      };
      let res = await FrontParentAnswerReport(params);
      if (res.data.success) {
        this.list = res.data.response;
        let params2 = {
          //CateId: this.typeList[this.currentIndex].CataId,
          UId: Number(this.$route.query.UId),
          // CycleIds: [Number(this.$route.query.CycleId)],
          CateId: Number(this.$route.query.CycleId),
          IsBaby: false,
        };

        return;
        let xhr = await GetintegrationbarValuesAdmin(params2);
        //console.log(xhr);
        setTimeout(() => {
          for (let ind = 0; ind < res.data.response.length; ind++) {
            let echarts = document.getElementById("reportEcharts" + ind);
            //console.log(echarts, "echarts");
            let myChart;
            if (echarts) {
              myChart = this.$echarts.init(echarts);
            }

            let option = {
              color: ["#7AC064", "#DF7C4B", "#438ACA"],
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "cross",
                  crossStyle: {
                    color: "#999",
                  },
                },
              },
              // toolbox: {
              //   feature: {
              //     dataView: { show: true, readOnly: false },
              //     magicType: { show: true, type: ["line", "bar"] },
              //     restore: { show: true },
              //     saveAsImage: { show: true },
              //   },
              // },
              legend: {
                data: xhr.data.response[ind].Legend_data,
              },
              xAxis: [
                {
                  axisLabel: {
                    align: "center",
                    interval: 0,
                    width: 30,
                  },
                  type: "category",
                  data: xhr.data.response[ind].Xaxis_data,
                  axisPointer: {
                    type: "shadow",
                  },
                },
              ],
              yAxis: [
                {
                  axisTick: {
                    show: false, //不显示坐标轴刻度线
                  },
                  axisLine: {
                    show: false, //不显示坐标轴线
                  },
                  type: "value",
                  // name: "Precipitation",
                  min: 0,
                  max: 12,
                  interval: 1,
                  // axisLabel: {
                  //   formatter: "{value} ml",
                  // },
                },
                // {
                //   type: "value",
                //   name: "Temperature",
                //   min: 0,
                //   max: 25,
                //   interval: 5,
                //   axisLabel: {
                //     formatter: "{value} °C",
                //   },
                // },
              ],
              series: xhr.data.response[ind].Series,
            };
            myChart.setOption(option, true);
            window.addEventListener("resize", () => {
              myChart.resize();
            });
          }
        }, 200);
      }
    },
  },
};
</script>
<style scoped lang="less">
.tui-headerName {
  font-size: 73px;
  font-weight: bold;
  text-align: center;
  color: #4f6585;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 60px;
}
.tui-headerTitle {
  width: 717px;
  height: 184px;
  font-size: 84px;
  font-weight: bold;
  text-align: center;
  color: #4f6585;
  display: flex;
  align-items: center;
  justify-content: center;
}
.header-all-title {
  padding-top: 192px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
#container {
  display: flex;
}
#pdfDom {
  background: #fff;
}
#container .columns {
  height: 100%;
}
#center {
  width: 1000px;
  background: #fff;
}
#left {
  flex: 1;
  height: 1000px;
}
#right {
  flex: 1;
  height: 1000px;
}
/deep/ .el-rate__icon {
  font-size: 35px;
  //margin: 0 60px;
  width: 120px;
}
/deep/ .el-rate {
  height: auto;
}
.statueTesting {
  // width: 100%;

  .statueTesting_title {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 600;
    // color: #333;
    padding: 38px 0 20px 0;
    text-align: center;
    color: #2268b3;
    // &::before {
    //   content: "";
    //   width: 10px;
    //   height: 20px;
    //   background: #5256c2;
    //   border-radius: 20px;
    //   display: inline-block;
    //   margin-right: 10px;
    //   position: relative;
    //   top: 3px;
    // }
  }
}
.tui-desc {
  font-size: 16px;
  font-family: PingFang SC;
  color: #333;
  line-height: 26px;
  letter-spacing: 2px;
  span {
    font-weight: 600;
    color: #2572ba;
  }
}
.tui-border {
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0 45px 0 45px;
}
.tui-images {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 20px;
  margin-bottom: 20px;
  img {
    object-fit: contain;
  }
}
.tui-box {
  width: 100%;
  //   padding-top: 171px;

  .tui-item {
    position: relative;

    height: 1421.42px;

    border-radius: 10px;

    .tui-rate {
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #999899;
      .tui-rate_name {
        width: 160px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        border-right: 1px solid #999899;
        text-align: center;
        line-height: 50px;
      }
      div {
        font-size: 19px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #2572ba;
      }
    }
    .tui-rate_boder {
      border: 1px solid #999899;
      width: 900px;
    }
    .tui-rate_boder .tui-rate:nth-last-child(1) {
      border-bottom: none;
    }

    .tui-item-title {
      width: 204px;
      height: 37px;
      background: linear-gradient(0deg, #4e57c6, #72a0ff);
      border-radius: 43px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 10px auto;
      div {
        color: #fff;
        font-size: 18px;
        padding-left: 10px;
      }
      i {
        color: #fff;
        font-size: 18px;
      }
    }
  }
}
.tui-Top {
  background-color: #91d660;
}
.tui-position {
  position: absolute;
  right: 20px;
  bottom: 20px;
  font-size: 22px;
  color: #fff;
}
.tui-header {
  width: 100%;
  height: 1421.42px;
  background: url(../../assets/report-titleNow.png) no-repeat;
  background-size: 100% 100%;
  position: relative;
  .tui-name {
    position: absolute;
    top: 406px;
    left: 0;
    right: 0;
    width: 439px;
    font-size: 130px;
    font-family: Lantinghei SC;
    font-weight: 800;
    color: #333333;
    margin: 0 auto;
    text-align: center;
    color: #2b74fa;
  }
  .tui-record {
    font-size: 130px;
    position: absolute;
    top: 660px;
    left: 0;
    right: 0;
    font-family: Lantinghei SC;
    font-weight: 800;
    color: #333333;
    margin: 0 auto;
    text-align: center;
    color: #2b74fa;
  }
  span {
    width: 140px !important;
  }
}
</style>